module.exports = __webpack_public_path__ + "static/media/reactions.269a23ee.svg";